<template>
  <v-container fluid pa-0 ma-0 class="user-select-none" fill-height>
    <v-layout row wrap class="ma-0" fill-height>

      <v-toolbar class="pa-0 ma-0 custom-toolbar"
                 color="white" fixed height="102px"
                 flat scroll-off-screen extension-height="46px">
        <v-layout row align-center style="height: 56px; width: 100%; flex-shrink: 0;" class="px-1 toolbar-shadow">
          <v-btn icon @click="$router.go(-1)">
            <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
          </v-btn>
          <h3 class="display-2" style="margin-bottom: 2px">{{ tourName }} {{ $route.name === 'TourGuide' ? '가이드' : $route.name === 'TourClass' ? '클래스' : '프로그램' }}</h3>
        </v-layout>

        <v-layout row align-center style="height: 46px; width: 100%;">
          <v-tabs v-if="$route.name === 'TourGuide'" v-model="activeGuideTab" slider-color="#4a4a4a" mandatory @change="onChangeTab" height="46px">
            <v-tab :ripple="false" v-for="tab of guideTab" :key="tab.idx" :href="`#tab-${tab.idx}`" class="tab">
              <span>{{ tab.name }}</span>
            </v-tab>
            <v-tabs-slider color="#4a4a4a" class="mx-2" style="width: auto; height: 3px; border-top-left-radius: 24px; border-top-right-radius: 24px;"></v-tabs-slider>
          </v-tabs>

          <v-tabs v-else v-model="activeProgramTab" slider-color="#4a4a4a" mandatory @change="onChangeTab" height="46px">
            <v-tab :ripple="false" href="#tab-0" class="tab">
              <span>전체</span>
            </v-tab>
            <v-tab v-if="idx !== 2" :ripple="false" href="#tab-1" class="tab">
              <span>무료</span>
            </v-tab>
            <v-tab :ripple="false" v-for="tab of tourNations" :key="tab.idx" :href="`#tab-${tab.idx}`" class="tab">
              <span>{{ tab.name }}</span>
            </v-tab>
            <v-tabs-slider color="#4a4a4a" class="mx-2" style="width: auto; height: 3px; border-top-left-radius: 24px; border-top-right-radius: 24px;"></v-tabs-slider>
          </v-tabs>
        </v-layout>

        <template v-slot:extension v-if="$route.name === 'TourGuide' && activeGuideTab !== 'tab-1'">
          <v-layout row align-center style="height: 46px; width: 100%;">
            <v-btn depressed block color="#f8f9ff" @click.stop="sheet = true" style="height: 46px;">
              <span class="nation-select-text">{{ tourNationName ? tourNationName : '나라를 선택해주세요' }}</span>
              <v-icon size="16px" color="#9497b2">$vuetify.icons.arrowDown</v-icon>
            </v-btn>
          </v-layout>
        </template>
      </v-toolbar>

      <v-flex xs12 class="pa-0" :style="{ marginTop: $route.name === 'TourGuide' && activeGuideTab !== 'tab-1' ? '150px' : '102px' }">
        <v-tabs-items v-model="activeGuideTab"
                      v-if="$route.name === 'TourGuide'"
                      class="fixed-tabs-container pa-0"
                      @change="onChangeTab">
          <v-tab-item v-for="tab of guideTab" :key="tab.idx" :value="`tab-${tab.idx}`" lazy>
            <Posts :menuIdx="tab.idx"
                   :tourIdx="idx"
                   :activeTab="activeGuideTab" />
          </v-tab-item>
        </v-tabs-items>

        <v-tabs-items v-else v-model="activeProgramTab" @change="onChangeTab">
          <v-tab-item value="tab-0" lazy>
            <Products :nationIdx="0"
                      :tourIdx="idx"
                      :type="$route.name === 'TourPrograms' ? 'program' : 'class'"
                      :activeTab="activeProgramTab" />
          </v-tab-item>
          <v-tab-item v-if="idx !== 2" value="tab-1" lazy>
            <Products :nationIdx="1"
                      :tourIdx="idx"
                      :type="$route.name === 'TourPrograms' ? 'program' : 'class'"
                      :activeTab="activeProgramTab" />
          </v-tab-item>
          <v-tab-item v-for="tab of tourNations" :key="tab.idx" :value="`tab-${tab.idx}`" lazy>
            <Products :nationIdx="tab.idx"
                      :tourIdx="idx"
                      :type="$route.name === 'TourPrograms' ? 'program' : 'class'"
                      :activeTab="activeProgramTab" />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>

    <v-bottom-sheet v-model="sheet">
      <v-card class="bottom-sheet-custom">
        <div class="bottom-sheet-custom-holder">
          <div class="bottom-sheet-custom-gradient-holder"></div>
          <v-list class="pa-0">
            <v-list-tile v-for="nation of tourNations" :key="nation.code"
                         class="nation-list-tile"
                         @click="changeNation(nation.idx, nation.name)">
              <span>{{ nation.name }}</span>
              <v-icon color="#ec2f54" size="16px" v-if="tourNationIdx === nation.idx">$vuetify.icons.confirm</v-icon>
            </v-list-tile>
          </v-list>
        </div>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import Posts from '@/views/TourTabs/Posts';
  import Products from '@/views/StoreTabs/Products';

  export default {
    name: 'TourMenu',
    props: {
      idx: {
        type: Number,
        required: true,
      }
    },
    components: { Posts, Products },
    data () {
      return {
        activeGuideTab: 'tab-1',
        activeProgramTab: 'tab-0',
        sheet: false,
        guideTab: [
          { idx: 1, name: '기본' },
          { idx: 2, name: '정보' },
          { idx: 3, name: '유학생' },
          { idx: 4, name: 'VLOG' },
        ],
      };
    },
    computed: {
      ...mapGetters('tour', [ 'tourName', 'tourNations', 'tourNationIdx', 'tourNationName' ]),
    },
    created () {
      if (this.$route.name !== 'TourGuide' && this.tourNationIdx > 1) {
        this.activeProgramTab = `tab-${this.tourNationIdx}`;
      }
    },
    methods: {
      ...mapActions('tour', [ 'setTourNation' ]),
      onChangeTab () {
        // this.$eventBus.$emit('tabChanged');
        // this.scrollToTop();
      },
      changeNation (nationIdx, nationName) {
        if (nationIdx === this.tourNationIdx) {
          this.setTourNation({ idx: 0, name: '' });
        } else {
          this.setTourNation({ idx: nationIdx, name: nationName });
        }
        this.sheet = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.custom-toolbar {
    .v-toolbar__content {
      padding: 0;
      display: flex;
      flex-direction: column;
    }
    .v-toolbar__extension {
      padding: 0;
    }
  }

  .toolbar-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .nation-select-text {
    color: #9497b2;
    font-size: 14px;
    letter-spacing: -0.58px;
    margin-right: 8px;
  }

  .bottom-sheet-custom {
    height: calc(100vh - 260px);
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    padding-top: 27px;
    &-holder {
      position: relative;
      padding-bottom: 168px;
      height: 100%;
      overflow-y: scroll;
      border-radius: 0 !important;
    }
    &-gradient-holder {
      position: fixed;
      bottom: 0;
      width: 100vw;
      height: 168px;
      z-index: 1;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
    }
  }
  /deep/.nation-list-tile .v-list__tile {
    height: 56px;
    padding: 0 32px;

    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.36px;
    font-weight: 700;

    display: flex;
    justify-content: space-between;
  }

  /deep/.tab > a {
    padding-left: 0;
    padding-right: 0;
    width: 80px;

    font-size: 16px;
    letter-spacing: -0.53px;
    font-weight: 700;
    color: #4a4a4a;
    /*opacity: 1;*/
  }
</style>
